import { render, staticRenderFns } from "./CostFooter.vue?vue&type=template&id=5828d583&scoped=true"
import script from "./CostFooter.vue?vue&type=script&lang=js"
export * from "./CostFooter.vue?vue&type=script&lang=js"
import style0 from "./CostFooter.vue?vue&type=style&index=0&id=5828d583&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828d583",
  null
  
)

export default component.exports